export type PlacePanelStage = "expanded" | "intermediate" | "compact";
export type PlacePanelSnapTarget = PlacePanelStage | "closed";

export const getPlacePanelSnapTarget = (
  stage: PlacePanelStage,
  dragOffset: number,
  threshold = 64,
): PlacePanelSnapTarget => {
  if (Math.abs(dragOffset) < threshold) return stage;
  if (dragOffset < 0) {
    if (stage === "compact") return "intermediate";
    return "expanded";
  }
  if (stage === "expanded") return "intermediate";
  if (stage === "intermediate") return "compact";
  return "closed";
};

export const defaultMobileAttributeForContext = (
  context: { id: string; label: string },
  requestedAttribute: string | null,
): string | null => {
  if (requestedAttribute) return requestedAttribute;
  return `${context.id} ${context.label}`.toUpperCase().includes("ANP")
    ? "nivel_mar"
    : null;
};
